// extracted by mini-css-extract-plugin
export default {"holder":"HomeTitle_holder__88Egt","homeText":"HomeTitle_homeText__Xmpw-","btns":"HomeTitle_btns__p5QFQ","homeTitle":"HomeTitle_homeTitle__ns-EY","picture":"HomeTitle_picture__OxvmN"};